import React from 'react'
import { InputText } from 'primereact/inputtext'
import { IconField } from 'primereact/iconfield'
import { useField } from 'formik'

export default function SharedInputText({
  placeholder = '',
  label = '',
  name = '',
  className = '',
  labelClassName = '',
  isIcon = false,
  icon,
  iconPos = 'left',
  iconClassName = '',
  defaultValue = '',
  type = 'text',
  ...props
}) {
  const [field, meta, helpers] = useField(name)

  React.useEffect(() => {
    if (type === 'date' && !field.value) {
      const today = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0]
      helpers.setValue(today)
    }
  }, [type, field.value, helpers])

  return (
    <div className='flex flex-col gap-1 w-full'>
      {label && (
        <label htmlFor={name} className={labelClassName || 'input-label'}>
          {label}
        </label>
      )}
      <IconField iconPosition={iconPos} className='relative w-full'>
        {isIcon && (
          <div
            className={`absolute top-1/2 transform -translate-y-1/2 ${iconPos === 'left' ? 'left-3' : 'left-auto right-3'
              } text-primary ${iconClassName}`}
          >
            {icon}
          </div>
        )}
        <InputText
          id={name}
          placeholder={placeholder}
          type={type}
          {...(type === 'number' ? { min: 0 } : {})}
          {...field}
          {...props}
          className={`input-field ${className} ${isIcon && iconPos === 'left'
            ? '!pl-10'
            : iconPos === 'right'
              ? '!pr-10'
              : ''
            } `}
        />
      </IconField>
      {meta?.error && meta?.touched && (
        <p className='text-[11px] text-red-500 mt-0.5'>
          {typeof meta?.error === 'string' ? meta?.error : JSON.stringify(meta?.error)}
        </p>
      )}
    </div>
  )
}
